/*
  Mixin used to manage user rights
*/
import { mapState } from 'vuex';

const SEPARATOR = ":";
const ADMIN = "ADMIN";
const EDITOR = "EDITOR";
const RUNNER = "RUNNER";
const OWNER = "OWNER";

export default  {

  computed: {
    ...mapState(['userInfo',]),
  },

  methods: {
    isAuthority(authority) {
      return this.userInfo && this.userInfo.authorities.includes(authority);
    },
    isAdmin() {
      return this.isAuthority(ADMIN);
    },
    isOwner(projectId) {
      return !!projectId && this.isAuthority(OWNER + SEPARATOR + projectId);
    },
    isEditor(projectId) {
      return !!projectId && (this.isAuthority(EDITOR + SEPARATOR + projectId)
        || this.isOwner(projectId));
    },
    isRunner(projectId) {
      return this.isAuthority(RUNNER + SEPARATOR + projectId)
        || this.isEditor(projectId);
    },
    getUserInfo() {
      this.$store.dispatch('loadUserInfo')
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err.messages] });
        });
    }
  },

  created() {
  }
};
